module.exports = __webpack_public_path__ + "static/media/29BDOS19.9ae66af2.jpg";